<div class="layout-box">

  <div class="top-bar">
    <h1>Note Mate</h1>
  </div>

  <div class="page-content">
    <router-outlet></router-outlet>
  </div>

</div>
